module.exports = __webpack_public_path__ + "static/yoast-740c71f9895787fa35c20580fd54192e.png";